import {
  customerSupportEmail,
  customerSupportEmailHref,
  customerSupportPhone,
  customerSupportTelHref,
  customerSupportWhatsApp,
  customerSupportWhatsAppHref,
  isSiteActive,
} from "@/shared/config/customerSupport";

export const carevincoSupportContent = {
  eyebrow: "Contact Carevinco",
  titleLead: "Need Trusted Home Nursing Care For ",
  titleAccent: "Your Loved One?",
  description: "Speak with the Carevinco team, share your care requirement, or start a care visit inquiry.",
  channels: [
    ...(isSiteActive ? [
      {
        id: "customer-care",
        title: "Customer Care",
        description: "Call the Carevinco support team for care guidance and appointment coordination.",
        value: customerSupportPhone,
        href: customerSupportTelHref,
        external: false,
      },
      {
        id: "whatsapp-support",
        title: "WhatsApp Support",
        description: "Message us for quick guidance, service questions, and visit coordination.",
        value: customerSupportWhatsApp,
        href: customerSupportWhatsAppHref,
        external: true,
      },
    ] : []),
    {
      id: "email-support",
      title: "Email",
      description: "Send service questions, provider queries, or support requests.",
      value: customerSupportEmail,
      href: customerSupportEmailHref,
      external: false,
    },
  ],
} as const;

export const carevincoAboutContent = {
  impact: {
    eyebrow: "Carevinco Impact",
    titleLead: "More Than Numbers. More ",
    titleAccent: "Human Care.",
    description: "Every number represents a family supported, a nurse verified, and a promise delivered with compassion.",
    homeDescription: "Every number represents a family supported, a nurse verified and a promise delivered with compassion.",
    metrics: [
      {
        value: "5000+",
        title: "Families Supported",
        description: "Happy families receive compassionate nursing care.",
      },
      {
        value: "150+",
        title: "Verified Nurses",
        description: "Identity, qualification, and background verified.",
        homeDescription: "Identity, qualification and background verified.",
      },
      {
        value: "2,500+",
        title: "Home Visits",
        description: "Professional nursing care delivered safely at home.",
      },
      {
        value: "98%",
        title: "Family Satisfaction",
        description: "Built through trust, compassion, and quality care.",
        homeDescription: "Built through trust, compassion and quality care.",
      },
      {
        value: "24/7",
        title: "Care Support",
        description: "Always ready to guide families whenever needed.",
      },
    ],
  },
  why: {
    eyebrow: "Why Families Choose Carevinco",
    titleAccent: "Trusted",
    titleLead: " Home Nursing, Built Around Your Family ",
    description:
      " Professional home nursing with compassionate care, verified nurses, and complete transparency—helping families feel confident and supported every day. ",
    homeDescription:
      " Professional home nursing with compassionate care, verified nurses and complete transparency—helping families feel confident and supported every day. ",
  },
} as const;
